<template>
  <layout>
    <template slot="authentication-content">
      <b-container fluid>
        <b-row align-h="center">
          <b-col lg="6">
            <b-card>
              <h1> {{ $t('password.title_mail') }} </h1>
              <br>
              <form v-loading="`<i class='ti ti-refresh ti-spin'></i>`" class="mb-2" @submit.prevent="submit">
                <vue-form-generator
                  :schema="schema"
                  :model="model"
                  :options="{ validationAfterLoad: true, validationAfterChanged: true }"
                />
                <b-button
                  type="submit"
                  variant="primary"
                  class="text-uppercase"
                  block
                >
                  {{ $t('password.btn_mail') }}
                </b-button>
              </form>
              <router-link :to="{ name: 'login' }">
                {{ $t('oauth.login.title') }}
              </router-link>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </layout>
</template>

<script>
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';
  import Layout from '@/views/Authentication/layout';

  export default {
    name: 'PasswordRequestView',
    components: {
      'vue-form-generator': VueFormGenerator.component,
      Layout,
    },
    data() {
      return {
        model: {},
        schema: {
          fields: [{
            disabled: false,
            id: 'username',
            inputType: 'email',
            label: this.$t('form.email'),
            maxlength: null,
            model: 'username',
            placeholder: this.$t('form.email'),
            readonly: false,
            required: true,
            type: 'input',
            autocomplete: 'username',
          }],
        },
      };
    },
    methods: {
      submit() {
        return this.$ajax.publicRequest('public/resetting/request', 'post', this.model).then((response) => {
          if (response.status) {
            this.$notify({
              title: this.$t('flashes.resetting_request.title'),
              text: this.$t('flashes.resetting_request.text'),
              type: 'success',
              duration: 30000,
            });
            this.$router.push({ name: 'login' });
          } else {
            this.$notify({
              title: this.$t('flashes.resetting_request.title'),
              text: this.$t(`flashes.resetting_request.${response.error || 'text_error'}`),
              type: 'error',
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .btn-fixed-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
